import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Grid, Avatar, Slide, Box, CircularProgress } from "@material-ui/core";
import axios from 'axios';
import CurrencyInput from 'react-currency-input';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

import InputAdornment from '@material-ui/core/InputAdornment';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import TextField from '@material-ui/core/TextField';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import LockIcon from '@material-ui/icons/Lock';

import SetOtpComponent from "./SetOtpComponent";
import StatusTransactionComponent from "./StatusTransactionComponent";

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import html2canvas from 'html2canvas';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%'
  },
  //Container styles
  container: {
    minHeight: "100%"
  },
  //Container styles
  body: {
    flexGrow: 1,
    height: '100vh',
    paddingTop: "2%"
  },
  //bar styles
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundImage: "linear-gradient(to right, rgb(102, 48, 194), #6730E3, rgba(83, 49, 177, 1), rgba(114, 48, 205, 1), rgba(150, 41, 230, 1))",
  },

  //CARD STYLE
  rootCard: {
    minWidth: 275,
    margin: theme.spacing(0, 0, 0, 0),
    height: "100%",
    alignItems: 'center',
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(0, 0, 0, 0),
    }
  },

  titleCard: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },

  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    color: theme.palette.common.white,
    backgroundColor: "#25d366",
  },
  contentAvatar: {
    marginTop: 30,
    backgroundImage: `url(${"../img/bg_icons_market-web.png"})`,
    textAlign: 'center'
  },
  contentBodyCard: {
    width: '100%',
    textAlign: 'center'
  },
  Avatar: {
    marginLeft: 10,
    height: 40,
    width: 40
  },

  buttonGoPage: {
    margin: theme.spacing(8, 0, 0, 0),
    borderRadius: '20px',
    backgroundImage: "linear-gradient(to right, rgb(102, 48, 194), #6730E3, rgba(83, 49, 177, 1), rgba(114, 48, 205, 1), rgba(150, 41, 230, 1))",
  },
  dividerLeft: {
    float: "left",
    marginTop: '8px',
    width: '30%',
    borderTop: 'solid 1px #D6D6D6',
    [theme.breakpoints.down("xs")]: {
      width: '25%',
    }
  },
  dividerRight: {
    float: "right",
    marginTop: '8px',
    width: '30%',
    borderTop: 'solid 1px #D6D6D6',
    [theme.breakpoints.down("xs")]: {
      width: '25%',
    }
  },
  marginTextFieldCardNumber: {
    width: '100%',
    textAlign: "center",
    fontSize: 40,
    marginTop: 20,
    borderRadius: 0,
    fontWeight: "bold",
    color: "black",
    border: 'solid 0px transparent',
    backgroundColor: "transparent",
    "&::placeholder": {
      textAlign: "center",
      fontSize: 40,
    },
    '&:focus': {
      outline: 'none'
    }
  },

  buttonNext: {
    background: "#000",
    borderRadius: '10px',
    marginTop: 30,
    width: "100%",
  },
  footer: {
    textAlign: 'center',
    bottom: 0,
    right: 0,
    position: "absolute",
    width: "100%",
    fontSize: '10px',
  },
  subtitle: {
    color: "gray"
  },
  titleName: {
    fontWeight: "bold"
  },
  titleSuccess: {
    fontWeight: "bold",
    fontSize: 30,
    marginTop: 20,
    [theme.breakpoints.down("xs")]: {
      fontSize: 20
    }
  },

  errorMessage: {
    fontSize: 18,
    marginTop: 10,
    marginBottom: 10,
    color: "red",
    [theme.breakpoints.down("xs")]: {
      fontSize: 10
    }
  },
  containedDiv: {
    backgroundColor: "#000",
    borderRadius: 10,
    color: "white",
    padding: 5,
    fontSize: 15
  },
  inputAdornment: {
    marginRight: theme.spacing(1.5), // Espacio entre el icono y el texto
    color: '#757575', // Color del icono
    fontSize: '1.2rem', // Tamaño del icono
  },
  selectGroup: {
    // Sobreescribe los estilos del InputBase subyacente del Select
    '& .MuiInputBase-root': {
      border: 'none', // Elimina el borde predeterminado del InputBase
      backgroundColor: 'transparent',
      padding: 0,
      width: '100%',
    },
    // Elimina el fondo azul al enfocar el Select
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
    // Elimina el subrayado predeterminado del Select
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
    // Estilo del icono de la flecha desplegable del Select
    '& .MuiSelect-icon': {
      color: '#757575', // Color personalizado para la flecha
    },
  },
  inputGroup: {
    display: 'flex',
    alignItems: 'center',
    // Borde más suave
    borderRadius: theme.shape.borderRadius, // Usa el radio de borde del tema
    backgroundColor: theme.palette.common.white, // Fondo blanco para los campos
    // boxShadow: '0 1px 4px rgba(0,0,0,0.08)', // Sombra sutil para los campos
    padding: theme.spacing(1.5, 2), // Ajusta el padding para el espacio interno
    width: '100%', // Asegura que ocupe todo el ancho disponible
    transition: 'box-shadow 0.3s ease-in-out, border-color 0.3s ease-in-out', // Transición suave
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)', // Sombra al pasar el ratón
      borderColor: theme.palette.primary.light, // Borde al pasar el ratón
    },
    '&:focus-within': { // Estilos al enfocar cualquier elemento dentro del grupo
      borderColor: theme.palette.primary.main, // Borde principal al enfocar
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)', // Sombra más fuerte al enfocar
    },
  },
  bottomInputGroup: {
    justifyContent: 'flex-start', // Alinea el contenido al inicio
    padding: theme.spacing(1.5, 1.5), // Ajusta el padding para la altura
  },
  bottomInputGroupRight: {
    justifyContent: 'flex-end', // Alinea el contenido al inicio
    padding: theme.spacing(1.5, 1.5), // Ajusta el padding para la altura
    [theme.breakpoints.down('sm')]: { // En pantallas pequeñas, ocupa todo el ancho
      marginTop: 10
    },
  },
  // Estilos específicos para los componentes TextField
  textFieldRoot: {
    width: '100%',
    // Sobreescribe los estilos del InputBase subyacente del TextField
    '& .MuiInputBase-root': {
      border: 'none', // Elimina el borde predeterminado
      backgroundColor: 'transparent',
      padding: 0,
      width: '100%',
      fontSize: '1rem', // Tamaño de fuente estándar
    },
    // Elimina el subrayado predeterminado del TextField
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
    // Estilo del placeholder
    '& .MuiInputBase-input::placeholder': {
      color: '#a0a0a0', // Color más claro para el placeholder
      opacity: 1, // Asegura que el placeholder no sea transparente
    },
  },

  bottomFieldsContainer: {
    marginTop: theme.spacing(1), // Espacio superior
    padding: theme.spacing(0), // Ajusta el padding si es necesario
    // Centrar el contenedor con margen automático horizontal si su ancho no es 100%
    width: 'calc(100% - 40%)', // Simula 30% de margen a cada lado (100% - (30% + 30%))
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('sm')]: { // En pantallas pequeñas, ocupa todo el ancho
      width: 'calc(100% - 20%)',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  bottomSelectContainer: {
    marginTop: theme.spacing(1), // Espacio superior
    width: 'calc(100% - 40%)', // Simula 30% de margen a cada lado (100% - (30% + 30%))
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 40,
    [theme.breakpoints.down('sm')]: { // En pantallas pequeñas, ocupa todo el ancho
      width: 'calc(100% - 20%)',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  lockIcon: {
    marginRight: theme.spacing(1),
    fontSize: '1.1rem'
  },

  // Estilos para el texto "Entorno seguro y protegido"
  secureEnvironmentText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(15), // Ajustado: Más espacio superior para empujar hacia abajo
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
    width: 'calc(100% - 60%)', // Mismo ancho que el contenedor de los campos inferiores
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: '#d9d9d9',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
      marginTop: theme.spacing(5)
    },
  },
  // Estilos para el pie de página
  footerText: {
    marginTop: theme.spacing(3), // Ajustado: Un poco más de espacio superior
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '0.8rem',
    lineHeight: 1.5,
  },

  // Estilos para el botón "CONTINUAR"
  continueButton: {
    backgroundColor: "#000", // Fondo negro
    color: theme.palette.common.white, // Texto blanco
    borderRadius: theme.shape.borderRadius, // Bordes redondeados
    padding: theme.spacing(1.5, 3), // Padding
    fontSize: '1rem', // Tamaño de fuente
    fontWeight: 'bold', // Negrita
    textTransform: 'none', // Sin mayúsculas
    // Sombra para el botón
    '&:hover': {
      backgroundColor: '#333333', // Color más oscuro al pasar el ratón
      boxShadow: '0 6px 12px rgba(0,0,0,0.3)',
    },
    width: 'calc(100% - 60%)', // Mismo ancho que el contenedor de los campos inferiores
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing(3), // Ajustado: Más espacio superior para empujar hacia abajo
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
    },
  },

  containerHeader: {
    border: "solid 1px black",
    borderRadius: 10,
    marginLeft: "30%",
    marginRight: "30%",
    [theme.breakpoints.down('sm')]: {
      marginLeft: "10%",
      marginRight: "10%",
    },
  },

  gridDebitoInmediato: {
    marginLeft: "30%",
    marginRight: "30%",
    marginTop: 40,
    [theme.breakpoints.down('sm')]: {
      marginLeft: "10%",
      marginRight: "10%",
    },
  },
  bankLogo: {
    width: 24, // Tamaño pequeño para el logo
    height: 24, // Tamaño pequeño para el logo
    marginRight: theme.spacing(5), // Espacio entre el logo y el texto
    borderRadius: '50%', // Para logos circulares, ajusta si tu logo es cuadrado
  },
  menuItemContent: {
    display: 'flex',
    alignItems: 'center', // Alinea el logo y el texto verticalmente
    width: '100%',
  },
  downloadReceiptButton: {
    backgroundColor: "transparent",
    boxShadow: '0 0px 0px rgba(0,0,0,0.3)',
    '&:hover': {
      backgroundColor: 'transparent', // Color más oscuro al pasar el ratón
    },
  },
  centeredContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%'
  }

}));

export default function AmountComponent(props) {
  const classes = useStyles();
  const [banks, setBanks] = useState([]);
  const [banksSelected, setBanksSelected] = useState('');
  const [telefonoFormatted, setTelefonoFormatted] = useState(''); // Estado para valor formateado
  const [telefonoRaw, setTelefonoRaw] = useState(''); // Estado para valor sin formato
  const [cedula, setCedula] = useState('');
  const [otp, setOtp] = useState('');
  const [currentScreen, setCurrentScreen] = useState(1);
  const [tipo, setTipo] = useState('V');
  const [referencia, setReferencia] = useState('000');
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [docId, setDocId] = useState(null)
  const [isBankEmpty, setIsTBankeEmpty] = useState(false);
  const [isCedulaEmpty, setIsCedulaEmpty] = useState(false);
  const [isTelefonoEmpty, setIsTelefonoEmpty] = useState(false);
  const [telefonoError, setTelefonoError] = useState('');
  const [bcvValue, setBcvValue] = useState()
  const [stopCoutDown, setStopCountDown] = useState(false)
  const [isRejected, setIsRejected] = useState(false);
  const [commerceId, setCommerceId] = useState('');
  const [token, setToken] = useState('');
  const receiptRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');

  // Funciones para formatear y desformatear el teléfono
  const formatPhoneNumber = (phone) => {
    const cleaned = phone.replace(/\D/g, '');

    // Nuevo: verificar si no hay dígitos
    if (cleaned === '') return '';

    const match = cleaned.match(/^(\d{0,4})(\d{0,3})(\d{0,2})(\d{0,2})$/);

    if (!match) return '';

    return `(${match[1]}${match[2] ? `)${match[2]}` : ''}${match[3] ? `-${match[3]}` : ''}${match[4] ? `-${match[4]}` : ''}`;
  };

  const unformatPhoneNumber = (formattedPhone) => {
    return formattedPhone.replace(/\D/g, '');
  };

  useEffect(() => {
    if (props.companyProps[10] !== undefined && props.companyProps[10] !== null) {
      //getBCV(props.companyProps[10]);
      getBanks(props.companyProps[10]);
    }
  }, [props.companyProps[10]])

  useEffect(() => {
    if (props.companyProps[10] !== undefined && props.companyProps[10] !== null) {
      setCommerceId(props.companyProps[10])
      setToken(props.companyProps[11])
    }
  }, [props.companyProps[10]])

  useEffect(() => {
    if (props.personData && props.personData[0] !== undefined && props.personData[0] !== null && props.personData[0] !== '') {
      const rawDocId = String(props.personData[0]).trim();
      setDocId(rawDocId);

      const match = rawDocId.match(/^([VEJGvejg])[\s\-_]*(.*)$/);
      if (match) {
        const letter = match[1].toUpperCase();
        const numericCedula = match[2].replace(/\D/g, '');
        setTipo(letter);
        setCedula(numericCedula);
      } else {
        const numericCedula = rawDocId.replace(/\D/g, '');
        setCedula(numericCedula);
      }
    }
  }, [props.personData ? props.personData[0] : null])

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const downloadReceipt = async () => {
    if (!receiptRef.current) return;
    try {
      const canvas = await html2canvas(receiptRef.current, {
        scale: 2,
        backgroundColor: '#ffffff',
        logging: false,
      });
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'comprobante-transaccion.png';
      link.click();
    } catch (error) {
      console.error('Error al generar el comprobante:', error);
    }
  };

  const getBanks = async (commerceid) => {
    try {
      const Url = process.env.REACT_APP_URL_BASE + process.env.REACT_APP_GET_BANKS
      let result = await axios.get(Url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'id_commerce': commerceid
        }
      })
      if (result.data.exito) {
        let banksData = result.data.data;
        let r4Bank = banksData.find(bank => bank.codigo_banco === '0169');
        banksData = banksData.filter(bank => bank.codigo_banco !== '0169');
        banksData.unshift(r4Bank);
        result.data.data = banksData;
        setBanks(result.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getBCV = async (commerceID) => {
    try {
      const Url = process.env.REACT_APP_URL_BASE + process.env.REACT_APP_GET_BCV
      const fechaActual = new Date();
      const fechaFormateada = fechaActual.getFullYear() + '-' +
        (fechaActual.getMonth() + 1).toString().padStart(2, '0') + '-' +
        fechaActual.getDate().toString().padStart(2, '0');

      let result = await axios.post(Url, {
        "Moneda": "USD",
        "Fechavalor": fechaFormateada,
        "commerceId": commerceID
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'id_commerce': commerceID
        }
      })
      if (result.data.exito) {
        setBcvValue(result.data.message.valor)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeBank = (event) => {
    setBanksSelected(event.target.value);
    setIsTBankeEmpty(false)
  };

  const handleChangeTipo = (event) => {
    setTipo(event.target.value);
  };

  const validarTelefonoVenezolano = (numero) => {
    const soloNumeros = numero.replace(/\D/g, '');
    if (soloNumeros.length > 11) return false;

    const prefijosPermitidos = ['0424', '0414', '0416', '0426', '0412','0422'];
    const prefijo = soloNumeros.substring(0, 4);

    if (soloNumeros.length >= 4 && !prefijosPermitidos.includes(prefijo)) {
      return false;
    }
    return true;
  };

  // Nuevo manejador de cambios para teléfono
  const handleTelefonoChange = (event) => {
    const value = event.target.value;

    // Guardar versión formateada (para mostrar)
    setTelefonoFormatted(formatPhoneNumber(value));

    // Guardar versión cruda (para procesamiento)
    const rawValue = unformatPhoneNumber(value);
    setTelefonoRaw(rawValue);

    // Validación (usa la versión cruda)
    if (validarTelefonoVenezolano(rawValue)) {
      setTelefonoError('');
      setIsTelefonoEmpty(false);
    } else {
      setTelefonoError('Formato de teléfono inválido');
      setIsTelefonoEmpty(true);
    }
  };

  const handleCedulaChange = (event) => {
    const value = event.target.value;
    const numericValue = value.replace(/\D/g, '');
    setCedula(numericValue);
    setIsCedulaEmpty(false)
  };

  const handleContinueClick = async () => {
    if (loading) return false;

    if (banksSelected === "" || !banksSelected) {
      setLoading(false)
      setIsTBankeEmpty(true)
      return false;
    }
    else if (cedula === "" || !cedula) {
      setLoading(false)
      setIsCedulaEmpty(true)
      return false;
    }
    else if (telefonoRaw === "" || !telefonoRaw) {
      setLoading(false)
      setIsTelefonoEmpty(true)
      return false;
    }

    // Validar formato del teléfono usando el valor crudo
    if (!validarTelefonoVenezolano(telefonoRaw) || telefonoRaw.length < 11) {
      setLoading(false)
      setTelefonoError('Formato de teléfono inválido');
      setIsTelefonoEmpty(true);
      return false;
    }

    console.log('Datos para OTP:', props.companyProps[11], commerceId)
    try {
      setLoading(true)
      let result = await axios.post(process.env.REACT_APP_URL_BASE + process.env.REACT_APP_GET_OTP, {
        Banco: banksSelected,
        Telefono: telefonoRaw, // Usar el valor crudo
        Cedula: tipo + cedula,
        Monto: props.companyProps[6].toString(),
        CommerceId: commerceId,
      },
        {
          headers: {
            'Authorization': `Bearer ${props.companyProps[11]}`,
            'id_commerce': commerceId
          }
        });

      if (result.data.exito) {
        setLoading(false);
        setIsRejected(false);
        setCurrentScreen(2);
        return true;
      }
      else {
        setLoading(false);
        setIsRejected(false);
        setAlertOpen(true)
        setMessageError('Todos los campos son obligatorios.' + result.data.mensaje);
        return false;
      }

    } catch (error) {
      setLoading(false);
      setIsRejected(false);
      console.error('Error al manejar el clic en Continuar:', error);
      setAlertOpen(true)
      setMessageError('Error al procesar la solicitud. Por favor, inténtalo de nuevo más tarde.');
      return false;
    }
  };

  // otpParam: código recibido por WebOTP (autollenado). Desde el botón AUTORIZAR
  // llega el evento de click, por eso se valida que sea string.
  const handleAuthorizationClick = async (otpParam) => {
    if (loading) return;
    const otpCode = typeof otpParam === 'string' ? otpParam : otp;

    try {
      setLoading(true)
      if (!otpCode || otpCode.length < 8) {
        setLoading(false)
        setAlertOpen(true)
        setMessageError('Por favor, ingresa un código OTP válido.');
        return;
      }

      const Url = process.env.REACT_APP_URL_BASE + process.env.REACT_APP_AUTHORIZE_PAYMENT;
      let amount = parseFloat(props.companyProps[6]).toFixed(2)

      const data = {
        Banco: banksSelected,
        Monto: amount.toString(),
        Telefono: telefonoRaw, // Usar el valor crudo
        Cedula: tipo + cedula,
        Nombre: "",
        Otp: otpCode,
        Concepto: props.companyProps[5],
        id_empresa: props.companyProps[7],
        id_usuario: props.companyProps[8],
        token: props.companyProps[9],
        rif: props.companyProps[4],
        commerceId: commerceId
      };

      let result = await axios.post(Url, data,);
      if (result.data.exito) {
        setLoading(false)
        setReferencia(result.data.referencia);
        setStatus(true);
        setIsRejected(false);
        setCurrentScreen(3);
      } else {
        setLoading(false);
        setIsRejected(true);
        if (result.data.codigo !== "TKCM") {
          if (result.data.codigo === "MD01") {
            setMessageError('Su banco no posee afiliación a débito inmediato');
          }
          setCurrentScreen(3);
        } else {
          setOtp("")
          setAlertOpen(true)
          setMessageError('Código de autorización inválido');
          setStatus(false);
          setStopCountDown(true)
        }
      }

    } catch (error) {
      setLoading(false)
      console.error('Error al manejar la autorización:', error);
      setIsRejected(true);
      setStopCountDown(true)
      setAlertOpen(true)
      setMessageError('Error al procesar la autorización. Por favor, inténtalo de nuevo más tarde.');
    }
  }

  const handleCloseAlert = () => {
    setAlertOpen(false);
  }

  const handleEnd = () => {
    props.setEndFlow(!props.endFlow);
    setIsRejected(false);
    setCurrentScreen(1);
  }

  const CustomAlert = (props) => {
    return (
      <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="error">
          {props.message}
        </Alert>
      </Snackbar>
    )
  }

  const formatAmount = (amount) => {
    if (!amount) return '0,00';
    const number = parseFloat(amount);
    return number.toLocaleString('es-VE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchDown = (event) => {
    event.stopPropagation();
  }

  const filteredBanks = banks && banks.filter((bank) =>
    bank.nombre_banco.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <React.Fragment>
      <Slide direction="right" in={true} mountOnEnter unmountOnExit>
        <div className={classes.body} ref={receiptRef}>
          <CustomAlert message={messageError} />
          <Grid container justify="center" className={classes.contentAvatar} spacing={2}>
            <Grid
              container
              item
              xs={12}
              className={classes.containerHeader}
            >
              <Grid item xs={1}>
                <Avatar alt="A" src={props.companyProps[0]} className={classes.Avatar}></Avatar>
              </Grid>
              <Grid item xs={11} style={{ textAlign: "center" }}>
                <Typography className={classes.titleName}>{props.companyProps[3]}</Typography>
                <Typography variant="body2" className={classes.subtitle}>{props.companyProps[4]}</Typography>
              </Grid>
            </Grid>

            <Grid
              container
              item
              xs={12}
              style={{ marginLeft: "20%", marginRight: "20%", marginTop: 40 }}
            >
              <Grid item xs={12}>
                {currentScreen === 3 && (
                  <div className={classes.centeredContent}>
                    {status ?
                      <img src="/img/success.png" alt="Imagen de éxito" style={{ width: 80, height: 80 }} /> :
                      <img src="/img/reject.png" alt="Imagen de rechazo" style={{ width: 80, height: 80 }} />
                    }
                    <Typography className={classes.titleSuccess}>
                      {status ? "Transacción exitosa" : "Transacción rechazada"}
                    </Typography>
                    {(!status && messageError !== "" && messageError) &&
                      <Typography className={classes.errorMessage}> {messageError}</Typography>
                    }
                  </div>
                )}

                {(currentScreen === 1 || currentScreen === 2) && (
                  <>
                    <Typography variant="h5" className={classes.titleName}>Pagar</Typography>
                    <Typography variant="h6" className={classes.subtitle}>{props.companyProps[5]}</Typography>
                  </>
                )}
              </Grid>

              {(currentScreen === 1 || currentScreen === 2) && (
                <Grid item xs={12}>
                  <form component='form'>
                    <Typography variant="h5" className={classes.marginTextFieldCardNumber}>
                      {formatAmount(props.companyProps[6]).toString()}  Bs.
                    </Typography>
                    {/* <Typography variant="h5" className={classes.subtitle}>
                      USD : {formatAmount((parseFloat(props.companyProps[6]) / parseFloat(bcvValue)).toFixed(2))}
                    </Typography> */}
                  </form>
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid container component="main">
            <div className={classes.contentBodyCard} >
              {(currentScreen === 1 || currentScreen === 2) && (
                <Grid item xs={12} className={classes.gridDebitoInmediato} >
                  <div className={classes.containedDiv}>
                    <Typography variant="title1"> Debito inmediato</Typography>
                  </div>
                </Grid>
              )}

              {currentScreen === 1 && (
                <>
                  {/* SELECT */}
                  <Grid item xs={12} className={classes.bottomSelectContainer} >
                    <Box className={`${classes.inputGroup} ${classes.selectGroup}`} style={{ border: `1px solid ${isBankEmpty ? '#f44336' : '#e0e0e0'}` }}>
                      <InputAdornment position="start" className={classes.inputAdornment}>
                        <AccountBalanceIcon />
                      </InputAdornment>
                      <FormControl className={classes.formControl}>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={banksSelected}
                          inputProps={{ 'aria-label': 'Selecciona un banco' }}
                          onChange={handleChangeBank}
                          displayEmpty
                          label="bancos"
                          disableUnderline
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 300,
                                paddingTop: 0,
                              }
                            },
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className={classes.searchContainer}>
                            <TextField
                              fullWidth
                              autoFocus
                              placeholder="Buscar banco..."
                              value={searchTerm}
                              onChange={handleSearchChange}
                              variant="outlined"
                              size="small"
                              onClick={(e) => e.stopPropagation()}
                              onKeyDown={handleSearchDown}
                              onFocus={(e) => e.stopPropagation()}
                            />
                          </div>
                          <MenuItem value="" disabled>
                            SELECCIONA UN BANCO
                          </MenuItem>
                          {(filteredBanks && filteredBanks.length > 0) && filteredBanks.map((bank) => (
                            <MenuItem key={bank.id_banco_operador} value={bank.codigo_banco}>
                              <Box className={classes.menuItemContent}>
                                <img src={bank.logo_banco} className={classes.bankLogo} />
                                {bank.nombre_banco}
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>

                  <Grid container style={{ marginTop: 10 }} className={classes.bottomFieldsContainer} >
                    <Grid item xs={4} sm={4}  >
                      <Box className={`${classes.inputGroup} ${classes.bottomInputGroup}`} style={{ border: "1px solid #e0e0e0" }}>
                        <InputAdornment position="start" className={classes.inputAdornment}>
                          <CreditCardIcon />
                        </InputAdornment>
                        <FormControl className={classes.formControl} >
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={tipo}
                            inputProps={{ 'aria-label': 'Selecciona un tipo' }}
                            onChange={handleChangeTipo}
                            displayEmpty
                            label="tipo"
                            disableUnderline
                            disabled={docId !== null && docId !== undefined}
                          >
                            <MenuItem value="V" > V </MenuItem>
                            <MenuItem value="E"> E </MenuItem>
                            <MenuItem value="J" > J </MenuItem>
                            <MenuItem value="G" > G </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>

                    <Grid item xs={8} sm={8}  >
                      <Box className={`${classes.inputGroup} ${classes.bottomInputGroup}`} style={{ border: `1px solid ${isCedulaEmpty ? '#f44336' : '#e0e0e0'}` }}>
                        <TextField
                          className={classes.textFieldRoot}
                          value={cedula}
                          onChange={handleCedulaChange}
                          placeholder="CEDULA"
                          type='tel'
                          disabled={docId !== null && docId !== undefined}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start" className={classes.inputAdornment}>
                                <CreditCardIcon />
                              </InputAdornment>
                            ),
                            disableUnderline: true,
                          }}
                          inputProps={{
                            maxLength: 11,
                          }}
                          error={cedula === ""}
                        />
                      </Box>
                    </Grid>
                  </Grid>

                  <Grid container justify="center" style={{ marginTop: 10 }} className={classes.bottomFieldsContainer}>
                    <Grid item xs={12} sm={12}>
                      <Box className={`${classes.inputGroup} ${classes.bottomInputGroupRight}`} style={{ border: `1px solid ${isTelefonoEmpty ? '#f44336' : '#e0e0e0'}` }}>
                        <TextField
                          className={classes.textFieldRoot}
                          value={telefonoFormatted} // Usar el valor formateado
                          onChange={handleTelefonoChange}
                          placeholder="(0424) XXX-XX-XX" // Nuevo placeholder con formato
                          type='tel'
                          error={!!telefonoError || isTelefonoEmpty}
                          helperText={telefonoError}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start" className={classes.inputAdornment}>
                                <PhoneIphoneIcon />
                              </InputAdornment>
                            ),
                            disableUnderline: true,
                          }}
                          inputProps={{
                            maxLength: 15, // Aumentado para incluir caracteres especiales
                            inputMode: 'tel',
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </>
              )}
              {currentScreen === 2 && (
                <SetOtpComponent
                  setOtp={setOtp}
                  otp={otp}
                  handleContinueClick={handleContinueClick}
                  handleAuthorizationClick={handleAuthorizationClick}
                  loading={loading}
                  stop={stopCoutDown}
                  setStopCountDown={setStopCountDown}
                  isRejected={isRejected}
                />
              )}

              {currentScreen === 3 && (
                <StatusTransactionComponent
                  datosUsuario={[
                    banksSelected,
                    tipo + cedula,
                    telefonoRaw, // Usar el valor crudo
                    referencia,
                    props.companyProps[5],
                    status,
                    props.companyProps[3],
                    props.companyProps[4],
                    props.companyProps[6]
                  ]}
                />
              )}

              {currentScreen === 3 &&
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '60px' }}>
                  <Button
                    variant="contained"
                    endIcon={<img src="/img/descargas.png" width={25} height={25} />}
                    onClick={downloadReceipt}
                    className={classes.downloadReceiptButton}
                  >
                    Descargar recibo
                  </Button>
                </div>
              }
            </div>
          </Grid>

          {/* Contenido inferior: "Entorno seguro y protegido", Botón y Pie de página */}
          <Box display="flex" flexDirection="column" alignItems="center" width="100%">
            <Typography variant="body2" className={classes.secureEnvironmentText}>
              <LockIcon className={classes.lockIcon} />
              Entorno seguro y protegido
            </Typography>

            {(currentScreen === 1 || currentScreen === 2) &&
              <Button
                variant="contained"
                className={classes.continueButton}
                disabled={loading || (currentScreen === 2 && otp.length < 8)}
                onClick={
                  currentScreen === 1 ? handleContinueClick :
                    currentScreen === 2 ? handleAuthorizationClick :
                      handleEnd
                }
              >
                {currentScreen === 1 && "CONTINUAR"}
                {currentScreen === 2 && "AUTORIZAR"}
                {(currentScreen === 2 && loading) && (<CircularProgress size={24} color="inherit" />)}
              </Button>
            }

            <Typography variant="caption" className={classes.footerText}>
              Esta transacción esta siendo procesada por<br />
              &copy; R4 . Banco Microfinanciero 2025 . J-31594102-3
            </Typography>
          </Box>
        </div>
      </Slide>
    </React.Fragment>
  )
}